import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const NotiFasleIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "NotiFasleIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M19.2025 19.1913H5.06149C4.40728 19.1913 3.79516 18.8997 3.38316 18.3908C2.97068 17.8829 2.81165 17.2233 2.94719 16.5823L4.64313 8.56938C5.38737 5.05223 8.53704 2.5 12.132 2.5C15.7269 2.5 18.8766 5.05224 19.6209 8.56938L21.3168 16.5823C21.4523 17.2233 21.2933 17.8829 20.8808 18.3908C20.4688 18.8997 19.8567 19.1913 19.2025 19.1913ZM12.132 3.5021C9.00727 3.5021 6.27057 5.72063 5.6237 8.77685L3.92776 16.7898C3.85485 17.1333 3.94048 17.4875 4.16165 17.7605C4.38281 18.0326 4.71065 18.1892 5.06149 18.1892H19.2025C19.5533 18.1892 19.8812 18.0326 20.1023 17.7605C20.3235 17.4875 20.4091 17.1333 20.3362 16.7898L18.6403 8.77685C17.9934 5.72063 15.2567 3.5021 12.132 3.5021Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M11.9671 22.5C9.89487 22.5 8.20921 20.8138 8.20921 18.7421C8.20921 18.4652 8.43331 18.2411 8.71026 18.2411H15.2234C15.5004 18.2411 15.7245 18.4652 15.7245 18.7421C15.7245 20.8138 14.0388 22.5 11.9671 22.5ZM9.25681 19.2432C9.49315 20.5242 10.6186 21.4979 11.9671 21.4979C13.3151 21.4979 14.4405 20.5242 14.6769 19.2432H9.25681Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default NotiFasleIcon;
